import Product from "onnit-ui/lib/@types/interfaces/product/BuyBoxProduct";
import MultiCustomPackageBuyBox from "onnit-ui/lib/buybox/simple/MultiCustomPackageBuyBox";
import { List, ListItem } from "onnit-ui/lib/text";
import React from "react";
import usePageData from "../../hooks/usePageData";
import useOnnitContext from "onnit-ui/lib/hooks/useOnnitContext";
import { BoxProps } from "onnit-ui/lib/box/Box";
import { ProductNameTransform } from "onnit-ui/lib/buybox/BuyBox";
import { MultiProductStackItem } from "../../interfaces/MultiProductStackItem";

interface ProductStackProps extends BoxProps {
    selectedProductId: number | null | undefined;
    productStack: MultiProductStackItem;
    imgUrl: string;
    imgParams: string;
    benefitsColor?: string;
    productNameTransform?: ProductNameTransform | undefined;
}

export const MultiProductStack = ({ selectedProductId, productStack, imgUrl, imgParams, productNameTransform, benefitsColor = "grays.5", ...rest }: ProductStackProps) => {
    const onnitContext = useOnnitContext();
    const { pageData, findProduct } = usePageData();

    if (!pageData || !onnitContext) return null;

    const selectedPrimaryProduct = selectedProductId ? findProduct(selectedProductId) : undefined;
    const packageProducts = productStack.packageProductIds.map(productId => findProduct(productId) as Product).filter(product => product);
    const primaryProducts = Object.keys(productStack.selectableProducts).map(productId => findProduct(parseInt(productId)) as Product).filter(product => product);
    const imageProducts: { [key: string]: string } = {};
    const secondaryProducts: Product[] = [];

    Object.entries(productStack.selectableProducts).map(([mainProductId, secondaryProduct], i) => {
        Object.entries(secondaryProduct).forEach(([secondaryProductId, img]) => {
            secondaryProducts[parseInt(secondaryProductId)] = findProduct(parseInt(secondaryProductId)) as Product;
            const key = `${mainProductId}_${secondaryProductId}`;
            imageProducts[key] = `${imgUrl}/${img}${imgParams}`;
        });
    });

    const filteredSecondaryProducts: Product[] = secondaryProducts.filter(product => product).filter(product => product);

    if (!primaryProducts.length || !filteredSecondaryProducts.length) {
        return null;
    }

    return (
        <MultiCustomPackageBuyBox
            {...rest}
            imgAltText={productStack.imgAltText}
            name={productStack.name}
            primaryProducts={primaryProducts}
            secondaryProducts={filteredSecondaryProducts}
            defaultSelectedProduct={selectedPrimaryProduct}
            packageProducts={packageProducts}
            images={imageProducts}
            productNameTransform={productNameTransform}
        >
            {productStack.benefits &&
                (
                    <List>
                        {productStack.benefits.map((benefit, i) => (
                            <ListItem color={benefitsColor} key={`benefit_${i}`} dangerouslySetInnerHTML={{ __html: benefit }} />
                        ), benefitsColor)}
                    </List>
                )
            }
        </MultiCustomPackageBuyBox>
    );
};